import React from 'react'
import { FormSelectField } from '@/components/Form/FormField'
import { LoadingOverlay } from '@/components/LoadingOverlay/LoadingOverlay'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { TickmillCompanyDto } from 'api/Identity/Types/Company'
import { Form, FormikErrors, FormikProps, withFormik } from 'formik'
import { FormSubmitValues } from 'utils/formValidation'

import { TickmillCompanyAllowedReferralsDto } from '../../../api/Trading-Accounts/Types/TickmillCompanyAllowedReferralsDto'

export interface AddEditIBEntityFormValues {
  allowedTickmillCompanyIdForReferral: number
  tickmillCompanyId: number
}

interface OuterProps {
  isOpen?: boolean
  onClose(): void
  entity?: TickmillCompanyAllowedReferralsDto
  tickmillCompanies: TickmillCompanyDto[]

  onSubmit(values: FormSubmitValues<AddEditIBEntityFormValues>): Promise<void>
}

const AddEditIBEntityFormUI: React.FC<FormikProps<AddEditIBEntityFormValues> & OuterProps> = (
  props
) => {
  const { handleSubmit, isSubmitting, errors, touched, tickmillCompanies, setFieldValue, isValid } =
    props

  const handleSubmitForm = () => {
    handleSubmit()
  }

  return (
    <Dialog open={props.isOpen} onOpenChange={(open) => !open && props.onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {props.entity ? 'Edit Referral Companies' : 'Add Referral Companies'}
          </DialogTitle>
        </DialogHeader>
        <Form>
          <div className='flex flex-col gap-4'>
            <FormSelectField
              name='tickmillCompanyId'
              label='Tickmill Company'
              options={tickmillCompanies.map((company) => ({
                id: company.id,
                name: company.name ?? '',
              }))}
              error={touched.tickmillCompanyId ? errors.tickmillCompanyId : undefined}
              onChange={(value) => setFieldValue('tickmillCompanyId', Number(value))}
            />
            <FormSelectField
              name='allowedTickmillCompanyIdForReferral'
              label='Allowed Tickmill Company for Referral'
              options={tickmillCompanies.map((company) => ({
                id: company.id,
                name: company.name ?? '',
              }))}
              error={
                touched.allowedTickmillCompanyIdForReferral
                  ? errors.allowedTickmillCompanyIdForReferral
                  : undefined
              }
              onChange={(value) =>
                setFieldValue('allowedTickmillCompanyIdForReferral', Number(value))
              }
            />
          </div>
        </Form>
        <DialogFooter>
          <Button onClick={handleSubmitForm} disabled={isSubmitting || !isValid} type='button'>
            Save
          </Button>
        </DialogFooter>
        <LoadingOverlay isLoading={isSubmitting} />
      </DialogContent>
    </Dialog>
  )
}

function dataToSubmit(
  values: AddEditIBEntityFormValues
): FormSubmitValues<AddEditIBEntityFormValues> {
  return {
    ...values,
  }
}

export const AddEditIBEntityForm = withFormik<OuterProps, AddEditIBEntityFormValues>({
  mapPropsToValues: ({ entity }) => {
    const currentEntity: Partial<TickmillCompanyAllowedReferralsDto> = entity || {}
    return {
      allowedTickmillCompanyIdForReferral: currentEntity?.allowedCompany?.id || 0,
      tickmillCompanyId: currentEntity?.tickmillCompany?.id || 0,
    }
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    try {
      await props.onSubmit(dataToSubmit(values))
    } finally {
      setSubmitting(false)
    }
  },
  validate: (values) => {
    const errors: FormikErrors<AddEditIBEntityFormValues> = {}
    if (!values.allowedTickmillCompanyIdForReferral) {
      errors.allowedTickmillCompanyIdForReferral = 'required'
    }
    if (!values.tickmillCompanyId) {
      errors.tickmillCompanyId = 'required'
    }
    return errors
  },
  enableReinitialize: true,
  validateOnChange: true,
})(AddEditIBEntityFormUI)
